const logo = '/resourceai.svg';

const Loader = () => {
  return (
    <div style={styles.overlay}>
      <div style={styles.pulseContainer}>
        <img src={logo} alt="ResourcAI" style={styles.logo} />
      </div>
      <style>{`
        @keyframes resourcAiPulse {
          0%, 100% { transform: scale(1); opacity: 0.8; }
          50% { transform: scale(1.1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  pulseContainer: {
    animation: 'resourcAiPulse 1.5s ease-in-out infinite',
    width: '80px',
    height: '80px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: '100%',
    height: '100%',
    objectFit: 'contain' as const,
  },
};

export default Loader;
